const stats = [
  { label: '설립', value: '2023', sub: 'AI 에너지 전문 기업' },
  { label: '핵심 기술', value: '4+', sub: '플랫폼 보유' },
  { label: '솔루션', value: '10+', sub: '산업 적용' },
  { label: '협력 네트워크', value: 'B2G/B2B', sub: '글로벌 협력' },
];

export default function StatsSection() {
  return (
    <section className="relative py-20 md:py-28 bg-enerverze-bg border-y border-enerverze-border">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-6 rounded-2xl bg-enerverze-card border border-enerverze-border">
              <p className="text-3xl md:text-4xl lg:text-5xl font-bold text-neon-cyan mb-2">
                {stat.value}
              </p>
              <p className="text-sm font-medium text-enerverze-text mb-1">{stat.label}</p>
              <p className="text-xs text-enerverze-subtle">{stat.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}